import { useEffect, useState } from 'react';

import { useLoading } from '@/hooks/use-loading.hook';
import { AppointmentRating } from '@/types';
import { getAppointmentPartialRating } from '@/services/appointment/get-appointment-partial-rating.service';

export const useFetchPartialRating = (id: string, enabled: boolean = true) => {
  const [rating, setRating] = useState<AppointmentRating['rating']>(null);
  const { isLoading, startLoading, stopLoading } = useLoading();

  useEffect(() => {
    if (!enabled || !id) {
      return;
    }

    let cancelled = false;

    async function fetchRating() {
      startLoading();
      try {
        const response = await getAppointmentPartialRating(id);
        if (!cancelled) {
          setRating(response);
        }
      } finally {
        if (!cancelled) {
          stopLoading();
        }
      }
    }

    fetchRating();

    return () => {
      cancelled = true;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, enabled]);

  return { rating, isLoading };
};
